export function workItemPath(workItemId: number, suffix: string): string {
  return `/teaching/work-items/${workItemId}${suffix}`
}

export function etagHeaders(etag?: string | null): { headers?: { 'If-Match': string } } {
  if (!etag) return {}
  return { headers: { 'If-Match': etag } }
}
